import moment from 'moment';
import React, { useState } from 'react';
import VoxelButton from '../../../components/voxel/Buttons/VoxelButton';
import VoxelDialog from '../../../components/voxel/Dialogs/VoxelDialog';
import VoxelDialogContent from '../../../components/voxel/Dialogs/VoxelDialogContent';
import VoxelTable from '../../../components/voxel/Tables/VoxelTable';
import VoxelTableCell from '../../../components/voxel/Tables/VoxelTableCell';
import VoxelTableRow from '../../../components/voxel/Tables/VoxelTableRow';
import { SubscriptionEventGq } from '../../../graphql/users/models/SubscriptionEventGq';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import VoxelButtonGrid from '../../../components/voxel/Buttons/VoxelButtonGrid';
import VoxelTablePagination from '../../../components/voxel/Tables/VoxelTablePagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faHistory } from '@fortawesome/pro-regular-svg-icons';

export interface SubscriptionEventsProps {
  subscriptionEvents: SubscriptionEventGq[];
}

export const SubscriptionEvents: React.FC<SubscriptionEventsProps> = ({ subscriptionEvents }) => {
  const [showEvents, setShowEvents] = useState(false);
  const [page, setPage] = useState(0);
  const amountPerPage = 10;
  const currentEvents = subscriptionEvents.slice(page * amountPerPage, (page + 1) * amountPerPage);

  return (
    <>
      {!!subscriptionEvents.length && (
        <VoxelButton
          title="View subscription events"
          onClick={() => setShowEvents(true)}
          size="md"
          color="light-gray"
          startIcon={<FontAwesomeIcon icon={faCalendar} />}
        />
      )}
      <VoxelDialog
        open={showEvents}
        closeOnBackdrop
        onClose={() => {
          setShowEvents(false);
          setPage(0);
        }}
        title="Subscription events"
      >
        <VoxelDialogContent classMinWidth="min-w-[1000px] h-[470px]">
          <VoxelTable>
            <tbody>
              {currentEvents.map((se) => (
                <VoxelTableRow key={se.eventTime}>
                  <VoxelTableCell className="text-nowrap" size='md'>
                    <VoxelText color="slight" span>
                      {moment.utc(se.eventTime).format('MMM Do')}
                    </VoxelText>
                  </VoxelTableCell>
                  <VoxelTableCell size='md'>
                    <VoxelText span>
                      {se.byUserEmail} {se.message}
                    </VoxelText>
                  </VoxelTableCell>
                </VoxelTableRow>
              ))}
            </tbody>
            <tfoot>
              <VoxelTablePagination
                align="left"
                rowsPerPage={amountPerPage}
                currentPage={page}
                onPageChange={(event, page) => setPage(page)}
                totalCount={subscriptionEvents.length}
                colSpan={2}
              />
            </tfoot>
          </VoxelTable>
        </VoxelDialogContent>
      </VoxelDialog>
    </>
  );
};

export default SubscriptionEvents;
